import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ShopProvider } from "@/context/ShopContext";
import Layout from "@/components/Layout";
import Kasir from "@/pages/Kasir";
import StokBarang from "@/pages/StokBarang";
import StokMasuk from "@/pages/StokMasuk";
import Laporan from "@/pages/Laporan";
import Riwayat from "@/pages/Riwayat";

function App() {
  return (
    <div className="App">
      <ShopProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Kasir />} />
              <Route path="/stok" element={<StokBarang />} />
              <Route path="/stok-masuk" element={<StokMasuk />} />
              <Route path="/laporan" element={<Laporan />} />
              <Route path="/riwayat" element={<Riwayat />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </ShopProvider>
    </div>
  );
}

export default App;
